/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Guide_DisclaimerInputs */

const en_shipping_guide_disclaimer = /** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: Shipping costs are estimates. Sellers will communicate any significant carrier adjustments prior to dispatch.`)
};

const es_shipping_guide_disclaimer = /** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota: Los costos de envío son estimaciones. Los vendedores comunicarán cualquier ajuste significativo antes del envío.`)
};

const fr_shipping_guide_disclaimer = /** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarque : Les frais d'expédition sont des estimations. Les vendeurs communiqueront tout ajustement important du transporteur avant l'expédition.`)
};

const de_shipping_guide_disclaimer = /** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis: Versandkosten sind Schätzungen. Verkäufer werden vor dem Versand über signifikante Anpassungen durch das Transportunternehmen informieren.`)
};

const id_shipping_guide_disclaimer = /** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan: Biaya pengiriman adalah estimasi. Penjual akan mengomunikasikan setiap penyesuaian kurir yang signifikan sebelum pengiriman.`)
};

/** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */
const ja_shipping_guide_disclaimer = en_shipping_guide_disclaimer;

/** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */
const zh_shipping_guide_disclaimer = en_shipping_guide_disclaimer;

/** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */
const ar_shipping_guide_disclaimer = en_shipping_guide_disclaimer;

/** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */
const it_shipping_guide_disclaimer = en_shipping_guide_disclaimer;

/** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */
const ru_shipping_guide_disclaimer = en_shipping_guide_disclaimer;

/** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */
const pt_shipping_guide_disclaimer = en_shipping_guide_disclaimer;

/** @type {(inputs: Shipping_Guide_DisclaimerInputs) => LocalizedString} */
const ko_shipping_guide_disclaimer = en_shipping_guide_disclaimer;

/**
* | output |
* | --- |
* | "Note: Shipping costs are estimates. Sellers will communicate any significant carrier adjustments prior to dispatch." |
*
* @param {Shipping_Guide_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_guide_disclaimer = /** @type {((inputs?: Shipping_Guide_DisclaimerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Guide_DisclaimerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_guide_disclaimer(inputs)
	if (locale === "es") return es_shipping_guide_disclaimer(inputs)
	if (locale === "fr") return fr_shipping_guide_disclaimer(inputs)
	if (locale === "de") return de_shipping_guide_disclaimer(inputs)
	if (locale === "ja") return ja_shipping_guide_disclaimer(inputs)
	if (locale === "zh") return zh_shipping_guide_disclaimer(inputs)
	if (locale === "ar") return ar_shipping_guide_disclaimer(inputs)
	if (locale === "id") return id_shipping_guide_disclaimer(inputs)
	if (locale === "it") return it_shipping_guide_disclaimer(inputs)
	if (locale === "ru") return ru_shipping_guide_disclaimer(inputs)
	if (locale === "pt") return pt_shipping_guide_disclaimer(inputs)
	return ko_shipping_guide_disclaimer(inputs)
});